import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'

export const isRichTextEmpty = data =>
  isEmpty(data) || filter(data, item => !!item.text || !!item.url).length === 0

export const stripTags = (html = '') => html.replace(/(<([^>]+)>)/ig, '')
